import React, { useRef, useState, useEffect } from 'react';
import { Slider } from 'antd';
import './index.less';
import { QuestionAudioPauseIcon, QuestionAudioPlayerIcon } from '@/svgs';

interface AudioPlayerProps {
    src: string;
}

const AudioPlayer: React.FC<AudioPlayerProps> = ({ src }) => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.addEventListener('timeupdate', handleTimeUpdate.bind(this));
            audio.addEventListener('loadedmetadata', handleLoadedMetadata);
            return () => {
                audio.removeEventListener('timeupdate', handleTimeUpdate.bind(this));
                audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
            };
        }
    }, []);

    const handleTimeUpdate = () => {
        if (audioRef.current) {
            const value = audioRef.current.currentTime;
            const duration = audioRef.current.duration;
            setCurrentTime(value);
            if (value === duration) {
                setIsPlaying(false);
            }
        }
    };

    const handleLoadedMetadata = () => {
        if (audioRef.current) {
            setDuration(audioRef.current.duration);
        }
    };

    const handlePlayPause = () => {
        const audio = audioRef.current;
        if (audio) {
            if (isPlaying) {
                audio.pause();
            } else {
                audio.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleSliderChange = (value: number) => {
        if (audioRef.current) {
            audioRef.current.currentTime = value;
            setCurrentTime(value);
        }
    };

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    return (
        <div className="sub-tiku__question-audio-player">
            <audio ref={audioRef} src={src} />
            <div className="sub-tiku__audio-player-btn" onClick={handlePlayPause}>
                {isPlaying ? <QuestionAudioPlayerIcon /> : <QuestionAudioPauseIcon />}
            </div>
            <Slider min={0} max={duration} value={currentTime} onChange={handleSliderChange} />
            <div className="sub-tiku__audio-player-tip">
                {formatTime(currentTime)}/{formatTime(duration)}
            </div>
        </div>
    );
};

export default AudioPlayer;
